import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnAuthService } from '@insight/serenity-auth';
import { PermissionsService } from 'src/app/shared/services/permissions.service';
import { PersonaService } from 'src/app/shared/api/services';
let envUrl = 'assets/environments/environment.json';

@Injectable()
export class PersonaGuard implements CanActivate {

    constructor(private _authService: SnAuthService, public router: Router, private PersonaService: PersonaService, private _permissionService: PermissionsService) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        await this._authService.isAuthenticated();
        var hasPerm = await this._permissionService.hasApplicationAccess();

        if(hasPerm) {
            let targetUrl = state.url;
            
            let canAccess = this._permissionService.canAccessRoute(targetUrl);
            if(canAccess) {
                return true;
            }

            // If they can't access the route but it's the landing page,
            // see if there are any valid routes to redirect them to
            if (state.url == '/landing' || state.url == '/') {
                let validRoute = this._permissionService.getFirstValidRoute();

                if(validRoute != '') {
                    this.router.navigateByUrl(`/${validRoute}`);
                } else {
                    console.error("Logged in user has no routes available to their persona.");
                    this.router.navigateByUrl('/wrong-personas');
                }
            } else {
                console.error("Logged in user does not have access to that route.");
                this.router.navigateByUrl('/wrong-personas');
            }
        } else {
            console.error("Logged in user does not have a Client Billing persona.");
            this.router.navigateByUrl('/wrong-personas');
        }

        return false;
    }
}
